import { render, staticRenderFns } from "./TableImport.vue?vue&type=template&id=52d4284a"
import script from "./TableImport.vue?vue&type=script&lang=js"
export * from "./TableImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports